import { render, staticRenderFns } from "./_newProductGroup.vue?vue&type=template&id=1c3c0c0c"
import script from "./_newProductGroup.vue?vue&type=script&lang=js"
export * from "./_newProductGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports